module.exports = __webpack_public_path__ + "img/do.2e442413.svg";